// import React, { useState, useEffect } from "react";
// import Highcharts from "highcharts";

// const manualData = {
//   "Category III Codes": {
//     "Prostate Ablation Procedure": {
//       "Anthem Participating Network": 272.95,
//       "BC ID Blue Value POS Network": 333.09,
//       "BC ID Preferred Blue Network": 333.09,
//       "BC ID Preferred Blue PPO Network": 294.65,
//     },
//     "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
//       "Anthem Participating Network": 147.22,
//       "BC ID Blue Value POS Network": 147.22,
//       "BC ID Preferred Blue Network": 147.22,
//       "BC ID Preferred Blue PPO Network": 147.22,
//     },
//   },
//   "Chemotherapy Drugs": {
//     "Chemotherapy Drugs": {
//       "Anthem Participating Network": 250.98,
//       "BC ID Blue Value POS Network": 243.03,
//       "BC ID Preferred Blue Network": 243.03,
//       "BC ID Preferred Blue PPO Network": 242.29,
//     },
//   },
// };

// const NetworkComparisonChart = () => {
//   const categories = Object.keys(manualData);
//   const [selectedCategory, setSelectedCategory] = useState(categories[0]);
//   const availableNetworks = Object.keys(
//     manualData[selectedCategory][Object.keys(manualData[selectedCategory])[0]]
//   );
//   const [selectedNetworks, setSelectedNetworks] = useState(availableNetworks);

//   useEffect(() => {
//     updateChart();
//   }, [selectedNetworks, selectedCategory]);

//   const updateChart = () => {
//     const subcategories = Object.keys(manualData[selectedCategory]);
//     const homeNetworkData = subcategories.map(
//       (sub) =>
//         manualData[selectedCategory][sub]["Anthem Participating Network"] || 0
//     );
//     const seriesData = [
//       {
//         name: "Home Network",
//         data: homeNetworkData,
//         color: "lightgrey",
//         borderColor: "grey",
//       },
//     ];

//     selectedNetworks.forEach((network) => {
//       seriesData.push({
//         name: network,
//         data: subcategories.map(
//           (sub) => manualData[selectedCategory][sub][network] || 0
//         ),
//         color: Highcharts.getOptions().colors[seriesData.length],
//       });
//     });

//     Highcharts.chart("container", {
//       chart: { type: "column" },
//       title: { text: `Network Comparison - ${selectedCategory}` },
//       xAxis: { categories: subcategories },
//       yAxis: { title: { text: "Performance" } },
//       plotOptions: {
//         column: { grouping: true, shadow: false, borderWidth: 0 },
//       },
//       series: seriesData,
//     });
//   };

//   return (
//     <div>
//       <select onChange={(e) => setSelectedCategory(e.target.value)}>
//         {categories.map((category) => (
//           <option key={category} value={category}>
//             {category}
//           </option>
//         ))}
//       </select>
//       <div>
//         <strong>Networks to Compare:</strong>
//         <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
//           {availableNetworks.map((network) => (
//             <button
//               key={network}
//               onClick={() =>
//                 setSelectedNetworks(
//                   selectedNetworks.includes(network)
//                     ? selectedNetworks.filter((n) => n !== network)
//                     : [...selectedNetworks, network]
//                 )
//               }
//               style={{
//                 padding: "5px 10px",
//                 background: selectedNetworks.includes(network)
//                   ? "blue"
//                   : "lightgrey",
//                 color: "white",
//                 border: "none",
//                 cursor: "pointer",
//               }}
//             >
//               {network}
//             </button>
//           ))}
//         </div>
//       </div>
//       <div id="container" style={{ width: "100%", height: "400px" }}></div>
//     </div>
//   );
// };

// export default NetworkComparisonChart;

// import React, { useState, useEffect } from "react";
// import Highcharts from "highcharts";
// import Highcharts3D from "highcharts/highcharts-3d";

// Highcharts3D(Highcharts);

// const manualData = {
//   "Category III Codes": {
//     "Prostate Ablation Procedure": {
//       "Anthem Participating Network": 272.95,
//       "BC ID Blue Value POS Network": 333.09,
//       "BC ID Preferred Blue Network": 333.09,
//       "BC ID Preferred Blue PPO Network": 294.65,
//     },
//     "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
//       "Anthem Participating Network": 147.22,
//       "BC ID Blue Value POS Network": 147.22,
//       "BC ID Preferred Blue Network": 147.22,
//       "BC ID Preferred Blue PPO Network": 147.22,
//     },
//   },
//   "Chemotherapy Drugs": {
//     "Chemotherapy Drugs": {
//       "Anthem Participating Network": 250.98,
//       "BC ID Blue Value POS Network": 243.03,
//       "BC ID Preferred Blue Network": 243.03,
//       "BC ID Preferred Blue PPO Network": 242.29,
//     },
//   },
// };

// const NetworkComparisonChart = () => {
//   const categories = Object.keys(manualData);
//   const [selectedCategory, setSelectedCategory] = useState(categories[0]);
//   const availableNetworks = Object.keys(
//     manualData[selectedCategory][Object.keys(manualData[selectedCategory])[0]]
//   );
//   const [selectedNetworks, setSelectedNetworks] = useState(availableNetworks);

//   useEffect(() => {
//     updateChart();
//   }, [selectedCategory]);

//   const updateChart = () => {
//     const subcategories = Object.keys(manualData[selectedCategory]);
//     const homeNetwork = availableNetworks[0];
//     const homeNetworkData = subcategories.map(
//       (sub) => manualData[selectedCategory][sub][homeNetwork] || 0
//     );

//     const seriesData = [
//       {
//         name: homeNetwork,
//         data: homeNetworkData,
//         color: "lightgrey",
//         borderColor: "grey",
//         zIndex: -1,
//         opacity: 1,
//         depth: 300,
//       },
//     ];

//     availableNetworks.slice(1).forEach((network) => {
//       seriesData.push({
//         name: network,
//         data: subcategories.map(
//           (sub) => manualData[selectedCategory][sub][network] || 0
//         ),
//         color: Highcharts.getOptions().colors[seriesData.length],
//         zIndex: 1,
//         depth: 45,
//       });
//     });

//     Highcharts.chart("container", {
//       chart: {
//         type: "column",
//         options3d: {
//           enabled: true,
//           alpha: 5,
//           beta: 5,
//           depth: 100,
//           viewDistance: 25,
//         },
//       },
//       title: { text: `Network Comparison - ${selectedCategory}` },
//       xAxis: { categories: subcategories },
//       yAxis: { title: { text: "Performance" } },
//       plotOptions: {
//         column: {
//           depth: 100,
//           grouping: true,
//           shadow: false,
//           borderWidth: 0,
//         },
//       },
//       series: seriesData,
//     });
//   };

//   return (
//     <div>
//       <select onChange={(e) => setSelectedCategory(e.target.value)}>
//         {categories.map((category) => (
//           <option key={category} value={category}>
//             {category}
//           </option>
//         ))}
//       </select>
//       <div id="container" style={{ width: "100%", height: "400px" }}></div>
//     </div>
//   );
// };

// export default NetworkComparisonChart;

// import React, { useState, useEffect } from "react";
// import Highcharts from "highcharts";
// import Highcharts3D from "highcharts/highcharts-3d";

// Highcharts3D(Highcharts);
// const manualData = {
//   "Category III Codes": {
//     "Prostate Ablation Procedure": {
//       "Anthem Participating Network": 272.95,
//       "BC ID Blue Value POS Network": 333.09,
//       "BC ID Preferred Blue Network": 333.09,
//       "BC ID Preferred Blue PPO Network": 294.65,
//     },
//     "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
//       "Anthem Participating Network": 147.22,
//       "BC ID Blue Value POS Network": 147.22,
//       "BC ID Preferred Blue Network": 147.22,
//       "BC ID Preferred Blue PPO Network": 147.22,
//     },
//     "Laser Ablation Procedures": {
//       "Anthem Participating Network": 605.01,
//       "BC ID Blue Value POS Network": 605.01,
//       "BC ID Preferred Blue Network": 605.01,
//       "BC ID Preferred Blue PPO Network": 605.01,
//     },
//     "Stereotactic Intracranial Lesion Ablation Procedure": {
//       "Anthem Participating Network": 338.44,
//       "BC ID Blue Value POS Network": 298.36,
//       "BC ID Preferred Blue Network": 298.36,
//       "BC ID Preferred Blue PPO Network": 338.44,
//     },
//     "Transnasal EGD and Capsule Endoscopy Procedures": {
//       "Anthem Participating Network": 584.68,
//       "BC ID Blue Value POS Network": 584.68,
//       "BC ID Preferred Blue Network": 584.68,
//       "BC ID Preferred Blue PPO Network": 584.68,
//     },
//     "Carotid Sinus Baroreflex Activation Device Procedures": {
//       "Anthem Participating Network": 278.66,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 278.66,
//     },
//     "Imaging, Testing, Implantation and Other Services": {
//       "Anthem Participating Network": 619.55,
//       "BC ID Blue Value POS Network": 619.55,
//       "BC ID Preferred Blue Network": 619.55,
//       "BC ID Preferred Blue PPO Network": 619.55,
//     },
//     "Insertion of Aqueous Drainage Device": {
//       "Anthem Participating Network": 207.97,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 207.97,
//     },
//     "Intracardiac Ischemia Monitoring Procedures": {
//       "Anthem Participating Network": 153.86,
//       "BC ID Blue Value POS Network": 153.86,
//       "BC ID Preferred Blue Network": 153.86,
//       "BC ID Preferred Blue PPO Network": 153.86,
//     },
//     "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
//       "Anthem Participating Network": 178.15,
//       "BC ID Blue Value POS Network": 178.15,
//       "BC ID Preferred Blue Network": 178.15,
//       "BC ID Preferred Blue PPO Network": 178.15,
//     },
//   },
//   "Chemotherapy Drugs": {
//     "Chemotherapy Drugs": {
//       "Anthem Participating Network": 250.98,
//       "BC ID Blue Value POS Network": 243.03,
//       "BC ID Preferred Blue Network": 243.03,
//       "BC ID Preferred Blue PPO Network": 242.29,
//     },
//   },
//   "Drugs Administered Other than Oral Method": {
//     "Drugs, Administered by Injection": {
//       "Anthem Participating Network": 260.7,
//       "BC ID Blue Value POS Network": 247.36,
//       "BC ID Preferred Blue Network": 247.36,
//       "BC ID Preferred Blue PPO Network": 252.38,
//     },
//     "Miscellaneous Drugs": {
//       "Anthem Participating Network": 234.78,
//       "BC ID Blue Value POS Network": 239.27,
//       "BC ID Preferred Blue Network": 239.27,
//       "BC ID Preferred Blue PPO Network": 235.47,
//     },
//     "Clotting Factors": {
//       "Anthem Participating Network": 227.49,
//       "BC ID Blue Value POS Network": 215.47,
//       "BC ID Preferred Blue Network": 215.47,
//       "BC ID Preferred Blue PPO Network": 214.66,
//     },
//     "Chemotherapy Drugs, Oral Administration": {
//       "Anthem Participating Network": 241.13,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 241.13,
//     },
//     "Immunosuppressive Drugs": {
//       "Anthem Participating Network": 188.53,
//       "BC ID Blue Value POS Network": 188.53,
//       "BC ID Preferred Blue Network": 188.53,
//       "BC ID Preferred Blue PPO Network": 188.53,
//     },
//   },
//   "Evaluation and Management": {
//     "Preventive Medicine Services": {
//       "Anthem Participating Network": 298.53,
//       "BC ID Blue Value POS Network": 288.5,
//       "BC ID Preferred Blue Network": 288.5,
//       "BC ID Preferred Blue PPO Network": 312.29,
//     },
//     "Transitional Care Management Services": {
//       "Anthem Participating Network": 309.17,
//       "BC ID Blue Value POS Network": 314.26,
//       "BC ID Preferred Blue Network": 314.26,
//       "BC ID Preferred Blue PPO Network": 322.86,
//     },
//     "Psychiatric Collaborative Care Management Services": {
//       "Anthem Participating Network": 293.26,
//       "BC ID Blue Value POS Network": 213.38,
//       "BC ID Preferred Blue Network": 213.38,
//       "BC ID Preferred Blue PPO Network": 293.26,
//     },
//     "Care Management Services": {
//       "Anthem Participating Network": 204.65,
//       "BC ID Blue Value POS Network": 204.65,
//       "BC ID Preferred Blue Network": 204.65,
//       "BC ID Preferred Blue PPO Network": 204.65,
//     },
//     "Newborn Care Services": {
//       "Anthem Participating Network": 389.88,
//       "BC ID Blue Value POS Network": 389.88,
//       "BC ID Preferred Blue Network": 389.88,
//       "BC ID Preferred Blue PPO Network": 389.88,
//     },
//     "Delivery/Birthing Room Attendance and Resuscitation Services": {
//       "Anthem Participating Network": 209.07,
//       "BC ID Blue Value POS Network": 209.07,
//       "BC ID Preferred Blue Network": 209.07,
//       "BC ID Preferred Blue PPO Network": 209.07,
//     },
//   },
//   "Medicine Services and Procedures": {
//     "Cardiovascular Procedures": {
//       "Anthem Participating Network": 360.68,
//       "BC ID Blue Value POS Network": 339.42,
//       "BC ID Preferred Blue Network": 339.42,
//       "BC ID Preferred Blue PPO Network": 359.71,
//     },
//   },
// };

// const NetworkComparisonChart = () => {
//   const categories = Object.keys(manualData);
//   const [selectedCategory, setSelectedCategory] = useState(categories[0]);
//   const availableNetworks = Object.keys(
//     manualData[selectedCategory][Object.keys(manualData[selectedCategory])[0]]
//   );
//   const [selectedNetworks, setSelectedNetworks] = useState(availableNetworks);

//   useEffect(() => {
//     updateChart();
//   }, [selectedCategory]);

//   const updateChart = () => {
//     const subcategories = Object.keys(manualData[selectedCategory]);
//     const homeNetwork = availableNetworks[0];
//     const homeNetworkData = subcategories.map(
//       (sub) => manualData[selectedCategory][sub][homeNetwork] || 0
//     );

//     const seriesData = [
//       {
//         name: homeNetwork,
//         data: homeNetworkData,
//         color: "lightgrey",
//         borderColor: "grey",
//         zIndex: -1,
//         opacity: 1,
//         depth: 100,
//       },
//     ];

//     availableNetworks.slice(1).forEach((network) => {
//       seriesData.push({
//         name: network,
//         data: subcategories.map(
//           (sub) => manualData[selectedCategory][sub][network] || 0
//         ),
//         color: Highcharts.getOptions().colors[seriesData.length],
//         zIndex: 1,
//         depth: 45,
//       });
//     });

//     Highcharts.chart("container", {
//       chart: {
//         type: "column",

//         options3d: {
//           enabled: true,
//           alpha: 0,
//           beta: 0,
//           depth: 100,
//           viewDistance: 0,
//         },
//       },
//       title: {
//         text: `Network Comparison - ${selectedCategory}`,
//         style: {
//           color: "#333333",
//           fontFamily: "'Montserrat', serif",
//           fontSize: "20px",
//           fontWeight: "bold",
//         },
//       },
//       xAxis: {
//         categories: subcategories,
//         lineColor: "#CDCDCD",
//         lineWidth: 1,
//         gridLineColor: "transparent", // Removed grid lines
//         labels: {
//           style: {
//             fontFamily: "'Roboto Flex', serif",
//             color: "#555555",
//             fontSize: "12px",
//           },
//         },
//       },
//       yAxis: {
//         title: {
//           text: "% Of Medicare",

//           style: {
//             fontFamily: "'Roboto Flex', serif",
//             color: "#555555",
//             fontWeight: "400",
//           },
//           margin: 5,
//         },
//         gridLineColor: "#EDEDED", // Light color (was too faint)
//         lineColor: "#CDCDCD", // Ensure a visible axis line
//         lineWidth: 1, // Add a border line to y-axis
//         labels: {
//           style: {
//             fontFamily: "'Roboto Flex', serif",
//             color: "#555555",
//             fontSize: "12px",
//           },
//         },
//       },
//       plotOptions: {
//         series: {
//           opacity: 1,
//           states: {
//             hover: {
//               enabled: false,
//             },

//             inactive: {
//               opacity: 1,
//             },

//             halo: {
//               opacity: 1,
//             },
//             select: {
//               enabled: false,
//               halo: {
//                 opacity: 1,
//               },
//             },
//           },

//           column: {
//             stacking: "percent", // Percentage stacking
//             borderWidth: 0.3,
//             dataLabels: {
//               enabled: true,
//               format: "{point.percentage:.0f}%",
//               style: {
//                 fontFamily: "'Roboto Flex', serif",
//                 fontSize: "0px",
//                 fontWeight: "400",
//                 color: "white",
//               },
//             },
//             borderRadius: 8,
//             depth: 45, // Reduced 3D depth for subtlety
//           },
//         },
//         column: {
//           depth: 0,
//           grouping: true,
//           shadow: false,
//           borderWidth: 0,
//           pointPadding: -0.4,
//           groupPadding: 0.2,
//         },
//       },
//       series: seriesData,
//     });
//   };

//   return (
//     <div style={{ padding: "5px" }}>
//       <select onChange={(e) => setSelectedCategory(e.target.value)}>
//         {categories.map((category) => (
//           <option key={category} value={category}>
//             {category}
//           </option>
//         ))}
//       </select>
//       <div id="container" style={{ width: "100%", height: "400px" }}></div>
//     </div>
//   );
// };

// export default NetworkComparisonChart;

import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import Highcharts3D from "highcharts/highcharts-3d";

Highcharts3D(Highcharts);

const manualData = {
  "Category III Codes": {
    "Prostate Ablation Procedure": {
      "Anthem Participating Network": 272.95,
      "BC ID Blue Value POS Network": 333.09,
      "BC ID Preferred Blue Network": 333.09,
      "BC ID Preferred Blue PPO Network": 294.65,
    },
    "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
      "Anthem Participating Network": 147.22,
      "BC ID Blue Value POS Network": 147.22,
      "BC ID Preferred Blue Network": 147.22,
      "BC ID Preferred Blue PPO Network": 147.22,
    },
    "Laser Ablation Procedures": {
      "Anthem Participating Network": 605.01,
      "BC ID Blue Value POS Network": 605.01,
      "BC ID Preferred Blue Network": 605.01,
      "BC ID Preferred Blue PPO Network": 605.01,
    },
    "Stereotactic Intracranial Lesion Ablation Procedure": {
      "Anthem Participating Network": 338.44,
      "BC ID Blue Value POS Network": 298.36,
      "BC ID Preferred Blue Network": 298.36,
      "BC ID Preferred Blue PPO Network": 338.44,
    },
    "Transnasal EGD and Capsule Endoscopy Procedures": {
      "Anthem Participating Network": 584.68,
      "BC ID Blue Value POS Network": 584.68,
      "BC ID Preferred Blue Network": 584.68,
      "BC ID Preferred Blue PPO Network": 584.68,
    },
    "Carotid Sinus Baroreflex Activation Device Procedures": {
      "Anthem Participating Network": 278.66,
      "BC ID Blue Value POS Network": "Unavailable",
      "BC ID Preferred Blue Network": "Unavailable",
      "BC ID Preferred Blue PPO Network": 278.66,
    },
    "Imaging, Testing, Implantation and Other Services": {
      "Anthem Participating Network": 619.55,
      "BC ID Blue Value POS Network": 619.55,
      "BC ID Preferred Blue Network": 619.55,
      "BC ID Preferred Blue PPO Network": 619.55,
    },
    "Insertion of Aqueous Drainage Device": {
      "Anthem Participating Network": 207.97,
      "BC ID Blue Value POS Network": "Unavailable",
      "BC ID Preferred Blue Network": "Unavailable",
      "BC ID Preferred Blue PPO Network": 207.97,
    },
    "Intracardiac Ischemia Monitoring Procedures": {
      "Anthem Participating Network": 153.86,
      "BC ID Blue Value POS Network": 153.86,
      "BC ID Preferred Blue Network": 153.86,
      "BC ID Preferred Blue PPO Network": 153.86,
    },
    "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
      "Anthem Participating Network": 178.15,
      "BC ID Blue Value POS Network": 178.15,
      "BC ID Preferred Blue Network": 178.15,
      "BC ID Preferred Blue PPO Network": 178.15,
    },
  },
  "Chemotherapy Drugs": {
    "Chemotherapy Drugs": {
      "Anthem Participating Network": 250.98,
      "BC ID Blue Value POS Network": 243.03,
      "BC ID Preferred Blue Network": 243.03,
      "BC ID Preferred Blue PPO Network": 242.29,
    },
  },
  "Drugs Administered Other than Oral Method": {
    "Drugs, Administered by Injection": {
      "Anthem Participating Network": 260.7,
      "BC ID Blue Value POS Network": 247.36,
      "BC ID Preferred Blue Network": 247.36,
      "BC ID Preferred Blue PPO Network": 252.38,
    },
    "Miscellaneous Drugs": {
      "Anthem Participating Network": 234.78,
      "BC ID Blue Value POS Network": 239.27,
      "BC ID Preferred Blue Network": 239.27,
      "BC ID Preferred Blue PPO Network": 235.47,
    },
    "Clotting Factors": {
      "Anthem Participating Network": 227.49,
      "BC ID Blue Value POS Network": 215.47,
      "BC ID Preferred Blue Network": 215.47,
      "BC ID Preferred Blue PPO Network": 214.66,
    },
    "Chemotherapy Drugs, Oral Administration": {
      "Anthem Participating Network": 241.13,
      "BC ID Blue Value POS Network": "Unavailable",
      "BC ID Preferred Blue Network": "Unavailable",
      "BC ID Preferred Blue PPO Network": 241.13,
    },
    "Immunosuppressive Drugs": {
      "Anthem Participating Network": 188.53,
      "BC ID Blue Value POS Network": 188.53,
      "BC ID Preferred Blue Network": 188.53,
      "BC ID Preferred Blue PPO Network": 188.53,
    },
  },
  "Evaluation and Management": {
    "Preventive Medicine Services": {
      "Anthem Participating Network": 298.53,
      "BC ID Blue Value POS Network": 288.5,
      "BC ID Preferred Blue Network": 288.5,
      "BC ID Preferred Blue PPO Network": 312.29,
    },
    "Transitional Care Management Services": {
      "Anthem Participating Network": 309.17,
      "BC ID Blue Value POS Network": 314.26,
      "BC ID Preferred Blue Network": 314.26,
      "BC ID Preferred Blue PPO Network": 322.86,
    },
    "Psychiatric Collaborative Care Management Services": {
      "Anthem Participating Network": 293.26,
      "BC ID Blue Value POS Network": 213.38,
      "BC ID Preferred Blue Network": 213.38,
      "BC ID Preferred Blue PPO Network": 293.26,
    },
    "Care Management Services": {
      "Anthem Participating Network": 204.65,
      "BC ID Blue Value POS Network": 204.65,
      "BC ID Preferred Blue Network": 204.65,
      "BC ID Preferred Blue PPO Network": 204.65,
    },
    "Newborn Care Services": {
      "Anthem Participating Network": 389.88,
      "BC ID Blue Value POS Network": 389.88,
      "BC ID Preferred Blue Network": 389.88,
      "BC ID Preferred Blue PPO Network": 389.88,
    },
    "Delivery/Birthing Room Attendance and Resuscitation Services": {
      "Anthem Participating Network": 209.07,
      "BC ID Blue Value POS Network": 209.07,
      "BC ID Preferred Blue Network": 209.07,
      "BC ID Preferred Blue PPO Network": 209.07,
    },
  },
  "Medicine Services and Procedures": {
    "Cardiovascular Procedures": {
      "Anthem Participating Network": 360.68,
      "BC ID Blue Value POS Network": 339.42,
      "BC ID Preferred Blue Network": 339.42,
      "BC ID Preferred Blue PPO Network": 359.71,
    },
  },
};

const NetworkComparisonChart = () => {
  const categories = Object.keys(manualData);
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);
  const availableNetworks = Object.keys(
    manualData[selectedCategory][Object.keys(manualData[selectedCategory])[0]]
  );
  // const [selectedNetworks, setSelectedNetworks] = useState(availableNetworks);

  useEffect(() => {
    updateChart();
  }, [selectedCategory]);

  const updateChart = () => {
    const subcategories = Object.keys(manualData[selectedCategory]).sort();
    const homeNetwork = availableNetworks[0];
    const homeNetworkData = subcategories.map(
      (sub) => manualData[selectedCategory][sub][homeNetwork] || 0
    );

    const seriesData = [
      {
        name: homeNetwork,
        data: homeNetworkData,
        color: "lightgrey",
        borderColor: "grey",
        zIndex: -1,
        opacity: 1,
        depth: 100,
      },
    ];

    // Define the color palette for the other networks
    const otherNetworkColors = ["#c0e7e7", "#507a8a", "#ffd29f"];

    availableNetworks.slice(1).forEach((network, index) => {
      seriesData.push({
        name: network,
        data: subcategories.map(
          (sub) => manualData[selectedCategory][sub][network] || 0
        ),
        color: otherNetworkColors[index % otherNetworkColors.length], // Cycle through the colors
        zIndex: 1,
        depth: 45,
      });
    });

    Highcharts.chart("container", {
      chart: {
        type: "column",
        options3d: {
          enabled: true,
          alpha: 0,

          beta: 0,
          depth: 100,
          viewDistance: 0,
          opacity: 1,
        },
      },
      title: {
        text: `Network Comparison - ${selectedCategory}`,
        style: {
          color: "#333333",
          fontFamily: "'Montserrat', serif",
          fontSize: "20px",
          fontWeight: "bold",
        },
      },

      tooltip: {
        headerFormat:
          '<span style="font-size: 14px; color: #5A5A5A;  max-width: 220px; white-space: normal; word-wrap: break-word;">{point.key}</span><br>' +
          '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
        pointFormat:
          "<div style='display:flex; flex-direction:row; align-items: center; justify-content: space-between;'  ><div style='margin-right: 0px; width:200px; white-space: normal; word-wrap: break-word;'> {series.name} </div> <div style=' display: flex;  justify-content: right; !important; width: 80px; '><b>{point.y}%</b></div> </div>",
        shared: true,
        backgroundColor: "rgba(255, 255, 255, 1)",
        borderColor: "#A9A9A9",
        borderRadius: 7,
        animation: false,
        hideDelay: 0,
        style: {
          color: "#333",
          fontFamily: "'Roboto Flex', serif",
          transition: "none",
          fontSize: "12px",
          padding: "8px",
          shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
          zIndex: 99999,
        },
        shadow: true,
        useHTML: true,
        outside: true,
      },

      xAxis: {
        categories: subcategories,
        lineColor: "#CDCDCD",
        lineWidth: 1,
        gridLineColor: "transparent", // Removed grid lines
        labels: {
          style: {
            fontFamily: "'Roboto Flex', serif",
            color: "#555555",
            fontSize: "12px",
          },
        },
      },
      yAxis: {
        title: {
          text: "% of Medicare",
          style: {
            fontFamily: "'Roboto Flex', serif",
            color: "#555555",
            fontWeight: "400",
          },
        },
        gridLineColor: "#EDEDED", // Light color (was too faint)
        lineColor: "#CDCDCD", // Ensure a visible axis line
        lineWidth: 1, // Add a border line to y-axis
        labels: {
          style: {
            fontFamily: "'Roboto Flex', serif",
            color: "#555555",
            fontSize: "12px",
          },
        },
      },
      plotOptions: {
        series: {
          opacity: 1,
          states: {
            hover: {
              enabled: false,
            },
            inactive: {
              opacity: 1,
            },
            halo: {
              opacity: 1,
            },
            select: {
              enabled: false,
              halo: {
                opacity: 1,
              },
            },
          },
          column: {
            stacking: "percent", // Percentage stacking
            borderWidth: 0.3,
            dataLabels: {
              enabled: true,
              format: "{point.percentage:.0f}%",
              style: {
                fontFamily: "'Roboto Flex', serif",
                fontSize: "0px",
                fontWeight: "400",
                color: "white",
              },
            },
            borderRadius: 8,
            depth: 45, // Reduced 3D depth for subtlety
          },
        },
        column: {
          depth: 0,
          grouping: true,
          shadow: false,
          borderWidth: 0,
          pointPadding: -0.4,
          groupPadding: 0.2,
        },
      },
      legend: {
        layout: "horizontal",
        align: "center",
        verticalAlign: "bottom",
        symbolHeight: 12,
        symbolWidth: 12,
        symbolRadius: 4,
        itemStyle: {
          color: "#333",
          fontSize: "13px",
          fontWeight: "500",
          fontFamily: "'Roboto Flex', serif",
        },
      },
      credits: {
        enabled: false,
      },
      series: seriesData,
    });
  };

  return (
    <div
      // style={{
      //   padding: "5px",
      //   display: "flex",
      //   flexDirection: "column",
      //   gap: "10px",
      //   backgroundColor: "#fff",
      //   padding: "20px",
      // }}
      className="bg-white p-4 "
      style={{ border: "none", borderRadius: "8px", margin: "0px 20px" }}
    >
      <label className="form-label">Select Category:</label>
      <div className="dropdown">
        <a
          className="btn btn-secondary dropdown-toggle"
          variant="primary"
          id="dropdown-basic"
          href="#"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {selectedCategory || "Select Category"}
        </a>

        <ul className="dropdown-menu">
          {categories.map((category) => (
            <li key={category}>
              <a
                className="dropdown-item"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedCategory(category);
                }}
              >
                {category}
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* <select
        className="form-select"
        onChange={(e) => setSelectedCategory(e.target.value)}
      >
        {categories.map((category) => (
          <option key={category} value={category}>
            {category}
          </option>
        ))}
      </select> */}
      <div id="container" style={{ width: "100%", height: "400px" }}></div>
    </div>
  );
};

export default NetworkComparisonChart;
